import Service from '@ember/service';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default class SelectedFlowManagerService extends Service {
  @service store;

  flowSelectedTask = task({ drop: true }, async (selectedFlow, entry) => {
    let signInFieldPageId = selectedFlow.belongsTo('signInFieldPage').id();

    if (signInFieldPageId == null) {
      // A flow without a sign-in-field page would crash the store's identifier
      // cache ("Expected either id or lid to be a valid string") and take down
      // the shared-device kiosk mid-sign-in (SQ-7544). Proceed without
      // sign-in fields instead.
      // eslint-disable-next-line no-console
      console.error(
        `[flow-selected] flow ${selectedFlow.id} has no sign-in-field-page; continuing without sign-in fields`,
      );
      await entry.save();
      return;
    }

    let signInFieldPage = this.store.peekRecord('sign-in-field-page', signInFieldPageId);
    if (!signInFieldPage) {
      let includes = [
        'sign-in-field-actions.sign-in-field',
        'actionable-sign-in-field-actions.actionable-sign-in-field',
        'actionable-sign-in-fields',
      ];
      signInFieldPage = await this.store.findRecord('sign-in-field-page', signInFieldPageId, {
        include: includes.map((include) => `sign-in-fields.${include}`).join(','),
      });
    }
    // Associate the sign-in-fields to the entry
    entry.signInFields = await signInFieldPage.signInFields;

    await entry.save();
  });
}
